"use strict";
import { useLoginWithEmail } from "@privy-io/react-auth";
import { ModalActionButton } from "components/Web3Provider/privy/ModalActionButton";
import { isTopazIdConnectorId } from "components/Web3Provider/privy/PrivyWagmiBridge";
import { useEffect, useRef, useState } from "react";
import { Flex, Input, Text, TouchableArea } from "ui/src";
import { useAccount, useDisconnect } from "wagmi";
export function EmailLogin({ onDone }) {
  const { connector, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const { sendCode, loginWithCode, state } = useLoginWithEmail({
    onComplete: () => {
      if (isConnected && !isTopazIdConnectorId(connector?.id)) {
        disconnect();
      }
      onDone?.();
    }
  });
  const awaitingCode = state.status === "awaiting-code-input" || state.status === "submitting-code";
  const sending = state.status === "sending-code";
  const submitting = state.status === "submitting-code";
  const errored = state.status === "error";
  const codeInputRef = useRef(null);
  const submitEmail = () => {
    if (email && !sending) {
      sendCode({ email });
    }
  };
  const submitCode = () => {
    if (code && !submitting) {
      loginWithCode({ code });
    }
  };
  useEffect(() => {
    if (awaitingCode) {
      codeInputRef.current?.focus();
    }
  }, [awaitingCode]);
  const inputProps = {
    placeholderTextColor: "$neutral3",
    backgroundColor: "$surface1",
    borderColor: "$surface3",
    borderWidth: 1,
    borderRadius: "$rounded12",
    px: "$spacing12",
    height: 48,
    color: "$neutral1",
    // Tamagui's default focus style drops the border; keep a visible (slightly brighter) one and remove
    // the browser outline so the field doesn't look borderless while typing.
    outlineWidth: 0,
    focusStyle: { borderColor: "$neutral3", borderWidth: 1 }
  };
  return <Flex gap="$gap8">
      {!awaitingCode ? <>
          <Input
    value={email}
    onChangeText={setEmail}
    placeholder="you@email.com"
    autoComplete="email"
    inputMode="email"
    autoFocus
    onSubmitEditing={submitEmail}
    {...inputProps}
  />
          <ModalActionButton
    label={sending ? "Sending code\u2026" : "Continue with email"}
    disabled={!email || sending}
    onPress={submitEmail}
  />
        </> : <>
          <Text variant="body4" color="$neutral2">
            Enter the code sent to {email}
          </Text>
          <Input
    ref={codeInputRef}
    value={code}
    onChangeText={(v) => setCode(v.replace(/[^0-9]/g, ""))}
    placeholder="123456"
    autoComplete="one-time-code"
    inputMode="numeric"
    textAlign="center"
    onSubmitEditing={submitCode}
    {...inputProps}
  />
          <ModalActionButton
    label={submitting ? "Verifying\u2026" : "Verify & sign in"}
    disabled={!code || submitting}
    onPress={submitCode}
  />
          <TouchableArea alignSelf="center" disabled={sending} onPress={() => sendCode({ email })}>
            <Text variant="body4" color="$neutral2" hoverStyle={{ color: "$neutral1" }}>
              {sending ? "Resending\u2026" : "Resend code"}
            </Text>
          </TouchableArea>
        </>}
      {errored && <Text variant="body4" color="$statusCritical">
          Couldn&apos;t sign in. Check the code and try again.
        </Text>}
    </Flex>;
}
